export const getJsonDataFromLocalStorage = <T>(input: string): T | null => {
  const localStorageData = localStorage.getItem(input)
  if (!localStorageData) {
    return null
  }

  try {
    return JSON.parse(localStorageData)
  } catch {
    return null
  }
}
